import * as utility from "../services"
import * as common_components from "../editor_common_components"
import * as propertyTypes from "../property_types"
import { MetadataIndex } from "../metadata_indexer"
import { Tree, NodeChangeMode, SortableTreeNode } from "../../core/components/sortableTree";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { ToolBoxCommand } from "../../core/components/sortableTreeSlot";
import { Dialog } from "../../core/components/dialog";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Button } from "../../core/components/button";
import { FormGenerator } from "../../core/components/formGenerator";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ReportingHelper, ConstraintError, Severity } from "../../core/util/reportingHelper";
import { TreeMetadataDescriptor, CustomReportMetadataDescriptor } from "./custom_report_metadata_descriptor";
import { Config } from "../../core/config/config";
import { ImageDocument, ImageDocumentField } from "../../core/components/imageDocument";
import { getGlobalSettings } from "../settings";
import { IsSearchField, IsSearchFieldProps } from "../../core/components/isSearchField";
import { ComponentHelper } from "../../core/util/componentHelper";
import { SearchHelper } from "../../core/util/searchfieldHelper";
import { Field } from "../../core/components/field";
import { FAIcon } from "../../core/components/faIcon";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import DocumentsListApp, { DocumentListItem, DocumentsListAppProps } from "../../documents/documents";
import { General } from "../../../siteManagement/general";
import InMemoryDocumentsService from "../../documents/in_memory_documents_service";
import { SheetEventType } from "../../../siteManagement/sheet";
import { UniqueQuestionNamePicker } from "./property_editor_extensions/unique_question_name_picker";
import { TagsPicker } from "./property_editor_extensions/tags_editor";
import { DocumentsPickerDialog, DocumentsPicker } from "./property_editor_extensions/documents_picker";
import { ScriptEditor } from "./property_editor_extensions/script_editor";
import HttpDocumentsService from "../../documents/http_document_service";
import { BasicDialog } from "../reactcomponent";
import { ReactComponentEditor } from "./property_editor_extensions/react_component_editor";
import { ErrorBoundary } from "../components/error_boundary";
import { PanelbarStructure } from "../../core/components/isPanelbarDetails";
import { Helper } from "../../core/util/helper";
import { RegionHeaderIcon } from "../../core/components/region.js";
import React from "react";
import { requireBase } from "../../core/require";
export class ServiceReportEditor extends React.Component<any, { treeMetadata: any, formMetadata: any, dataSources: any }> {
    private cachedDocs: DocumentListItem[] = [];
    private _reportingHelper = ReportingHelper.create();
    private entity: any = { IsNew: false, IsWatchable: false, IsWatched: false, RecordRight: { CanRead: true, CanWrite: true } };
    private defaultTranslations;
    private javaScriptFunctions;

    constructor(props) {
        super(props);

        const s = getGlobalSettings();
        let settings = s.GetSettings();
        if (!settings) {
            settings = { INNO_BASE_PATH: Config.baseUrl };
            s.SetSettings(settings);
        }
    }
    private metadataDescriptor: TreeMetadataDescriptor = new CustomReportMetadataDescriptor().reportDescriptor;

    async componentDidMount() {

        if (this.props.entity && this.props.entity.ReportStructure) {
            this.defaultTranslations = this.props.entity.ReportStructure.DefaultTranslations;
            this.javaScriptFunctions = this.props.entity.ReportStructure.JavaScriptFunctions;

            if (this.props.entity.ReportStructure.Id) {
                await this.getDocuments(this.props.entity.ReportStructure.Id);
            }
        }

        let treeMetadata: any = { Title: "", Sections: null };

        if (this.props.entity.ISGuid) {
            this.UpdateMetadata(this.props.entity.ReportStructure);
        }
        else {
            this.UpdateMetadata(treeMetadata);
        }
    }

    handleMetadataChanged = (metadata) => {
        const bla = this.getTranslatedText(this.props.entity.ReportStructure.TranslatableTitle);
        this.props.entity.ReportStructure.Title = bla;
        if (metadata.hasValueChanged && this.props.context.appHelper) {
            this.props.context.appHelper.setEntityDirtyState(true);
        }
        const meta = this.generateFormMetadata(metadata.sections);
        this.setState({ formMetadata: meta.formMetadata, dataSources: meta.dataSources });
    }

    getTranslatedText = (values) => {
        if (values) {
            const result = values.filter(v => v["Language"] == Config.user.languageId)
            if (result && result.length > 0) {
                return result[0]["Translation"]
            }
        }
        return "";
    }

    private getDocuments = async (metadataId) => {
        const documentsService = new HttpDocumentsService();
        const docs: JsonResultClass<DocumentListItem[]> = await documentsService.GetDocuments(8, metadataId || this.state.treeMetadata.Id, null);
        this.cachedDocs = docs.Data;
        return docs;
    }

    private UpdateMetadata(treeMetadata: { Title: string; Sections: any; }) {
        this.props.entity.ReportStructure = treeMetadata;
        const meta = this.generateFormMetadata(treeMetadata.Sections);
        this.setState({ treeMetadata: treeMetadata, formMetadata: meta.formMetadata, dataSources: meta.dataSources });
    }

    private generateFormMetadata(sections): { formMetadata: any, dataSources: any } {
        const fields = [];
        const dataSources = [];
        if (!sections) {
            return { formMetadata: fields, dataSources: dataSources };
        }
        const tmpMeta = this._reportingHelper.createMetaData(sections, this.defaultTranslations, fields, this.entity, true, this.cachedDocs, null, null, this.javaScriptFunctions);
        for (let i = 0; i < tmpMeta.dataSources.length; i++) {
            dataSources[tmpMeta.dataSources[i].name] = tmpMeta.dataSources[i].data;
        }
        return { formMetadata: fields, dataSources: dataSources };
    }

    render() {
        if (!this.state || !this.state.formMetadata) {
            return null;
        }
        return <MetadataEditor
            hideTree={this.state.treeMetadata.Released || this.state.treeMetadata.Disabled}
            treeMetadataDescriptor={this.metadataDescriptor}
            treeMetadata={this.state.treeMetadata}
            formMetadata={this.state.formMetadata}
            onMetadataChanged={this.handleMetadataChanged}
            entity={this.entity}
            reportingHelper={this._reportingHelper}
            getDocuments={this.getDocuments}
            dataSorces={this.state.dataSources}
            handleEval={this.props.handleEval}
        />
    }
};


interface WebsMSMetadataEditorState {
    selectedMetadata?
    selectedInstance?
    selectedRawMetadata?
    selectedEntity?
    addFieldDialog?
    isExternalUser?
}

interface MetadataEditorProps {
    treeMetadata: any;
    treeMetadataDescriptor: TreeMetadataDescriptor;
    formMetadata: any;
    dataSorces: any;
    onMetadataChanged: any;
    hideTree: boolean;
    entity: any;
    reportingHelper: any;
    getDocuments: any;
    handleEval?(action: string, prepare?: any);
}

class MetadataEditor extends React.Component<MetadataEditorProps, WebsMSMetadataEditorState> {
    constructor(props) {
        super(props);
        this.state = { selectedRawMetadata: null };
    }

    handleSettingsChanged = () => {
        this.forceUpdate();
        this.props.onMetadataChanged({
            sections: this.props.treeMetadata.Sections,
            selectedElementId: this.state.selectedRawMetadata ? this.state.selectedRawMetadata.guid : null,
            hasValueChanged: true
        });
    }

    handleSelectedComponentChanged = (node) => {
        if (node.descriptor.getMetadata) {
            const metadataClass = node.descriptor.getMetadata(node);
            if (metadataClass) {
                const instance = propertyTypes.InstanceLoader.getInstance(metadataClass, null, null);
                instance.hydrateFromJS(node.metadata);
                const metadata = instance.getMetadata();

                this.setState({ selectedMetadata: metadata, selectedEntity: node.metadata, selectedInstance: instance });
            }

        } else {
            this.setState({ selectedMetadata: null, selectedInstance: null });
        }
        this.props.onMetadataChanged({
            sections: this.props.treeMetadata.Sections,
            selectedElementId: this.state.selectedRawMetadata ? this.state.selectedRawMetadata.guid : null
        });
    }

    handleSave = () => {
        const getDescriptionUrl = "Reporting/SaveReportStructure";
        debugger;
        utility.httpService.postJson(Config.baseUrl + getDescriptionUrl, this.props.treeMetadata, (result) => {
            const sections = result.Data.Sections;
        }, null, null, true);
    }

    renderTree = () => {
        return (<div style={{ overflow: "auto" }}>
            <div style={{ flex: 1 }}>
                <CustomReportTree
                    treeData={this.props.treeMetadata}
                    treeMetadataDescriptor={this.props.treeMetadataDescriptor}
                    onMetadataChanged={this.props.onMetadataChanged}
                    onSelectionChanged={this.handleSelectedComponentChanged}
                />
            </div>
        </div>)
    }

    handleChange = (field, value) => {
        if (field) {
            MetaDataHelper.setFieldValue(this.props.entity, field.model, value);
        }

        this.props.onMetadataChanged({
            sections: this.props.treeMetadata.Sections,
            selectedElementId: this.state.selectedRawMetadata ? this.state.selectedRawMetadata.guid : null
        });
    }

    createTypingForMultiAnswer = (answers): string => {
        const usedUniqueNames = Object.keys(answers).map((key) => { return '"' + key + '":boolean' });
        let code = "{" + usedUniqueNames.join(',') + "}";
        return code;
    }

    createTypingForObject = (answers): string => {
        const usedUniqueNames = Object.keys(answers).map((key) => { return '"' + (answers[key] == null ? key + ":any" : key + ":" + this.createTypingForMultiAnswer(answers[key])) + '"' });
        let code = "let answers:{" + usedUniqueNames.join(',') + "}";
        return code;
    }

    getLibCode = (): string => {
        const answers = this.props.reportingHelper.getEntityForScripts(this.props.treeMetadata.Sections, {})

        return answers.typeInfo;
    }

    getCustomEditor = (type: string): { component: typeof React.Component, customProps: any } => {
        if (type == "UNIQUEQUESTIONNAME") {
            const usedUniqueNames = Object.keys(this.props.reportingHelper.getEntityForScripts(this.props.treeMetadata.Sections, {}));
            return {
                component: UniqueQuestionNamePicker, customProps: { usedUniqueNames: usedUniqueNames }
            };
        }
        else if (type == "TAGSPROPERTY") {
            return {
                component: TagsPicker, customProps: null
            };
        }
        else if (type == "DOCUMENTPICKER") {
            return {
                component: DocumentsPicker, customProps: { getDocumentsFunction: this.props.getDocuments }
            };
        }
        else if (type == "CR_SCRIPT_EDITOR") {

            return {
                component: ScriptEditor, customProps: { extraLibs: [{ code: this.getLibCode() }] }
            };
        }
        else if (type == propertyTypes.PropertyTypes.REACTTEMPLATEPROPERTY) {
            return {
                component: ReactComponentEditor, customProps: { extraLibs: [{ code: "" }] }
            };
        }
    }

    render() {
        let editor = null;
        if (this.state.selectedMetadata) {
            this.state.selectedInstance.hydrateFromJS(this.state.selectedEntity);
            editor = <div style={{ overflow: "auto", width: "300px" }}><common_components.PropertiesEditor
                componentState={this.state.selectedInstance}
                properties={this.state.selectedMetadata}
                selectedElement={this.state.selectedEntity}
                onSettingsChanged={this.handleSettingsChanged}
                customComponentResolver={this.getCustomEditor} />
            </div>
        }
        let message = null;
        if (this.props.treeMetadata.Disabled) {
            message = "This report is disabled.";
        }
        else if (this.props.treeMetadata.Released) {
            message = "This report is released and can't be changed.";
        }
        const releasedIndicator = this.props.treeMetadata.Released || this.props.treeMetadata.Disabled ? <div style={{
            fontSize: "12pt",
            fontWeight: "bold",
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex",
            height: "50px",
            margin: "5px",
            alignItems: "center"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}>{message}</div></div> : null

        return (
            <FullHeightContainer classes="flex-container--column">
                {releasedIndicator}
                <div style={{ height: "100%", display: "flex", flexDirection: "row" }}>
                    {!this.props.hideTree ? this.renderTree() : null}
                    <FullHeightContainer classes='reporting-wrapper__fields-wrapper'>
                        <FormGenerator
                            handleEval={Helper.hasValue(this.props.handleEval) ? this.props.handleEval : () => true}
                            regions={this.props.formMetadata}
                            dataSources={this.props.dataSorces}
                            onChange={this.handleChange}
                            entity={this.props.entity}
                        />
                    </FullHeightContainer>
                    {editor}
                </div>
            </FullHeightContainer>
        )
    }
}

interface reportQuestion {
    QuestionId?
    Text?
    Type
    AnswerReferences?
    Size?: number
    RowSize?: number
    QuestionDataType?: number
}

class CustomReportTree extends React.Component<{ treeData: any, treeMetadataDescriptor: TreeMetadataDescriptor, onMetadataChanged: any, onSelectionChanged: any }, { selectedMetada: any, selectedNode: any, showAddComponentDialog: boolean }> {
    private key: string = kendo.guid();
    private treeRef: Tree;
    private treeNodeBuilder = new TreeMetadataBuilder();
    private root = {
        Title: "UI", canHaveChildren: true, children: []
    };
    private _contentRenderer = (node: any) => {
        const descriptor: TreeMetadataDescriptor = node.descriptor;
        return (
            <div className="item item-card">
                <span className="title">
                    {node.descriptor ? descriptor.getTitle(node.metadata) : node.Title}
                </span>
            </div>);
    }

    constructor(props) {
        super(props);
        this.state = { showAddComponentDialog: false, selectedMetada: null, selectedNode: null };
    }

    UNSAFE_componentWillMount() {
        const descriptor = this.props.treeMetadataDescriptor;
        const nodeInfo = this.treeNodeBuilder.getNodeInfo(descriptor, this.props.treeData);
        this.root.children[0] = nodeInfo;
    }

    private isChangeAllowed = (node: any, parent: any, index: number, targetParent: any, targetIndex: number, mode: NodeChangeMode): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!targetParent.descriptor) {
                resolve(false);
            }
            if (node.descriptor.descriptorName == 'questionDescriptor' && targetParent.descriptor.descriptorName == 'sectionDescriptor') {
                resolve(true);
            }
            else if (node.descriptor.descriptorName == 'sectionDescriptor' && targetParent.descriptor.descriptorName == 'servicereportDescriptor') {
                resolve(true);
            }
            else {
                resolve(false);
            }
        });
    }

    private handleAfterChange = (node: any, previousParent: any, previousIndex: number, currentParent: any, currentIndex: number, mode: NodeChangeMode) => {
        if (mode == NodeChangeMode.Move) {

            if (previousParent.childArray == currentParent.childArray) {
                currentParent.childArray.splice(currentIndex, 0, currentParent.childArray.splice(previousIndex, 1)[0]);
            }
            else {
                previousParent.childArray.splice(previousIndex, 1)

                if (!currentParent.childArray) {
                    const arrayName = currentParent.descriptor.childrenArrayName();
                    currentParent.metadata[arrayName] = [];
                    currentParent.childArray = currentParent.metadata[arrayName];
                }
                currentParent.childArray.splice(currentIndex, 0, node.metadata);
            }
        }
        else if (mode == NodeChangeMode.Delete) {
            previousParent.childArray.splice(previousIndex, 1);
        }

        this.props.onMetadataChanged({
            sections: this.props.treeData.Sections

        });
    }

    private canShowCommand = (type: ToolBoxCommand, node: any, name?: string): boolean => {
        if (type == ToolBoxCommand.Custom) {
            if (node.descriptor.descriptorName == "servicereportDescriptor" && name == "addSection") {
                return true;
            }
            else if (node.descriptor.descriptorName == "sectionDescriptor" && (name == "addComponent" || name == "addImage" || name == "addreactComponent")) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (type == ToolBoxCommand.Append || type == ToolBoxCommand.Copy || type == ToolBoxCommand.Cut) {
            return false;
        }
        else if (node.descriptor.descriptorName == "servicereportDescriptor" && type == ToolBoxCommand.Delete) {
            return false;
        }
        else {
            return true;
        }
    }

    private handleAddRowOrSection = (commandName: string, node: any) => {
        const selectedMeta = this.state.selectedMetada;
        const childrenArray = node.descriptor.childrenArrayName();

        if (!selectedMeta[childrenArray]) {
            selectedMeta[childrenArray] = [];
        }

        node.childArray = selectedMeta[childrenArray];
        var newNode = { Title: "New section" };
        const newTreeNode = this.treeNodeBuilder.getNodeInfo(new CustomReportMetadataDescriptor().sectionDescriptor, newNode);

        node.children.push(newTreeNode);

        selectedMeta[childrenArray].push(newNode);
        this.treeRef.refresh();

        this.props.onMetadataChanged({
            sections: this.props.treeData.Sections
        });
    }

    private handleAddComponent = (commandName: string, node: any) => {
        this.setState({ showAddComponentDialog: true });
    }

    private handleSelectionChanged = (node: any) => {
        if (this.state.selectedMetada) {
            this.state.selectedMetada._isSelected = false;
        }
        node.metadata._isSelected = true;
        this.setState({ selectedMetada: node.metadata, selectedNode: node })
        this.props.onSelectionChanged(node);
    }

    private addInputControl = (newMetadata: reportQuestion[]) => {
        console.log(newMetadata)
        const selectedMeta = this.state.selectedMetada;
        const node = this.state.selectedNode;
        const childrenArray = node.descriptor.childrenArrayName();

        if (!selectedMeta[childrenArray]) {
            selectedMeta[childrenArray] = [];
        }

        node.childArray = selectedMeta[childrenArray];

        for (var rq of newMetadata) {
            const newTreeNode = this.treeNodeBuilder.getNodeInfo(new CustomReportMetadataDescriptor().questionDescriptor, rq);
            node.children.push(newTreeNode);
            selectedMeta[childrenArray].push(rq);
        }

        this.treeRef.refresh();

        this.props.onMetadataChanged({
            sections: this.props.treeData.Sections
        });
    }

    private handleAddImage = () => {
        this.addInputControl([{ Type: 12, Size: 12, RowSize: 1 }]);
    }

    private handleAddReact = () => {
        this.addInputControl([{ Type: 13, Size: 12, RowSize: 1 }]);
    }

    render() {
        const addComponentDialog = this.state.showAddComponentDialog ? <AddFieldDialog onAddComponents={this.addInputControl} onClose={() => this.setState({ showAddComponentDialog: false })} /> : null
        return <>
            {addComponentDialog}
            <Tree
                ref={(e) => this.treeRef = e}
                key={this.key}
                tree={this.root}
                isChangeAllowed={this.isChangeAllowed}
                afterChange={this.handleAfterChange}
                noderRenderer={this._contentRenderer}
                afterSelect={this.handleSelectionChanged}
                commands={{
                    canShow: this.canShowCommand, custom: [
                        { hint: "Add section", iconName: "plus", name: "addSection", onClick: this.handleAddRowOrSection },
                        { hint: "Add component", iconName: "plus", name: "addComponent", onClick: this.handleAddComponent },
                        { hint: "Add image", iconName: "image", name: "addImage", onClick: this.handleAddImage },
                        { hint: "Add react component", iconName: "atom", name: "addreactComponent", onClick: this.handleAddReact }
                    ]
                }}
            />
        </>
    }
}

export class StaticImage extends React.Component<any, any> {
    private getFilename = (doc): string => {
        if (doc.Filename) {
            return doc.Filename
        }
        else if (this.props.field.cachedDocs) {
            const cachedDoc = this.props.field.cachedDocs.filter(x => x.Isguid == doc.Id);
            return cachedDoc && cachedDoc.length > 0 ? cachedDoc[0].FileName : "";
        }
    }

    renderDocuments = () => {
        const idf: ImageDocumentField = {
            readOnlyImage: true,
            type: "",
            model: ""
        };

        const imageExtensions = /(\.jpg|.jpeg|\.png|\.gif)$/i;
        if (!this.props.field.pictures || this.props.field.pictures.length <= 0) {
            return null;
        }
        return this.props.field.pictures.map(p => {
            const filename = this.getFilename(p); return imageExtensions.exec(filename)
                ? <ImageDocument key={p.Id} field={idf} value={p.Id} />
                : <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <FAIcon name="file"></FAIcon><div >{filename}</div>
                </div>
        });
    }

    render() {
        return this.renderDocuments();
    }
}

export class ReactTemplateComponent extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);

        this.state = { reactComponent: this.props.field.transpiledCode ? this.initReactComponent(this.props.field.transpiledCode) : null };
    }

    initReactComponent = (sourceCode: string): any => {
        try {
            const require = (modules, callback) => { requireBase("/app/statistics/statistic_components", modules, callback) };
            const result = this.evalWithCustomRequire(sourceCode, require);
            if (result) {
                return result;
            }
        } catch (e) {

        }
        return null;
    }

    evalWithCustomRequire = (sourceCode: string, require) => {
        return eval(sourceCode);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.field && this.props.field && this.props.field.transpiledCode != nextProps.field.transpiledCode) {
            this.setState({ reactComponent: this.initReactComponent(nextProps.field.transpiledCode) });
        }
    }


    render() {
        return (
            <ErrorBoundary>
                {this.state.reactComponent ? React.createElement(this.state.reactComponent, { reportId: this.props.field.reportId, api: this.props.field.api }) : null}
            </ErrorBoundary>)
    }
};

export class SectionSeparator extends React.Component<any, any> {
    handleClick = (e) => {
        e.preventDefault();
        this.props.field.atlasNode["_isCollapsed"] = !this.props.field.atlasNode["_isCollapsed"];
        this.props.field.api.setFields();
    }

    render() {
        const symbol = !this.props.field.atlasNode["_isCollapsed"] ? "minus" : "plus";
        const warning = <ConstraintsIndicator constraints={this.props.field.constraintViolations} />;
        return <div style={{ flex: 1 }} className="section-seperator">
            <div className="section-seperator__title" onClick={this.handleClick}><RegionHeaderIcon open={!this.props.field.atlasNode["_isCollapsed"]}></RegionHeaderIcon><span style={{ paddingLeft: "5px" }}>{this.props.field.title}</span></div>
            <div style={{ paddingTop: "5px" }}>
                {warning}
            </div>
        </div>
    }
}

export class FieldWrapperEditUi extends React.Component<any, any> {
    private field: Field;


    render() {
        const style: React.CSSProperties = {};
        if (this.props.field.isSelected) {
            style.borderColor = "red";
            style.borderStyle = "solid";
            style.borderWidth = "1px"
        }
        const wrapped = this.props.field.wrappedField;
        let hiddenIndicator = null;
        if (!wrapped.visible) {
            wrapped.visibleCondition = null;
            wrapped.visible = true;
            hiddenIndicator = <FAIcon name="eye-slash" sameWidth={true} />
        }
        const warning = <ConstraintsIndicator constraints={wrapped.constraintViolations} />;
        const documentUpload = wrapped.appName != "StaticImage" && wrapped.allowDocuments ? <FAIcon name="paperclip" sameWidth={true} /> : null;
        return <>
            <div style={style}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {hiddenIndicator}

                    <div style={{ flex: 1 }}>
                        <Field ref={(e) => this.field = e} field={wrapped} entity={this.props.entity} dataSource={this.props.dataSource} context={this.props.context}
                            handleEval={this.props.handleEval} handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            onChange={this.props.onChange} onDataLoaded={this.props.onDataLoaded} commandManager={this.props.commandManager} />
                        {warning}
                    </div>
                    {documentUpload}
                </div>
                {wrapped.remark ? <RemarkPanelbar key={wrapped.remark}>{wrapped.remark}</RemarkPanelbar> : null}
            </div>
        </>
    }
}
export class RemarkPanelbar extends React.Component<any, any> {
    private _rootDiv: HTMLDivElement;
    private _mountingpoint: HTMLLIElement;

    componentDidMount() {
        $(this._rootDiv).children().kendoPanelBar().data("kendoPanelBar");
    }

    render() {
        const link = <FAIcon name="edit" />;
        const data: any = {};
        return <div ref={(e) => { this._rootDiv = e }}>
            <PanelbarStructure label={Config.translations.remark} keyPropValue="d" iconName="file">
                <pre style={{ whiteSpace: "pre-wrap", lineHeight: "20px" }}>{this.props.children}</pre>
            </PanelbarStructure></div>
    }
}


export class FieldWrapperInputValues extends React.Component<any, any> {
    handleAddAttachement = () => {
        console.log(Config.settings);
        if (!Config.settings.documentBasePathIsConfigured) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.GeneralSettings.DokumentenBasispfadNichtGesetzt"));
            return;
        }
        if (this.props.field && this.props.field.wrappedField && this.props.field.wrappedField.model) {
            const entityKey = this.getEntityKey();
            if (!this.props.entity["_Docs"]) {
                this.props.entity["_Docs"] = {};
            }
            if (!this.props.entity["_Docs"][entityKey]) {
                this.props.entity["_Docs"][entityKey] = [];
            }
            const sheet = General.Sheet.Manager.createSheet();
            const documentListAppProps: DocumentsListAppProps = {
                context: { contextType: "Questions" },
                entity: { RecordRight: this.props.entity.RecordRight },
                documentService: new InMemoryDocumentsService(this.props.entity["_Docs"][entityKey], { canRead: true, canWrite: this.props.entity.RecordRight.CanWrite, isExtern: false }),
                type: 10
            };
            sheet.show(() => {
                sheet.setTitle(Helper.getTranslation("Dokument.Search"));
                sheet.mountContent(DocumentsListApp, documentListAppProps);
                sheet.bind(SheetEventType.Close, this.handleSheetClose)
            });
        }
    }

    handleSheetClose = () => {
        this.forceUpdate();
    }

    getEntityKey = (): string => {
        return this.props.field.wrappedField.model.substring(7, this.props.field.wrappedField.model.length);
    }
    getDocumentsIndicator = () => {
        const docs = this.props.entity["_Docs"];
        return docs && docs[this.getEntityKey()] && docs[this.getEntityKey()].length > 0 ? <div style={{
            position: "absolute",
            backgroundColor: "lightblue",
            top: "20px",
            left: "-5px",
            borderRadius: "50%",
            borderColor: "black",
            borderStyle: "solid",
            borderWidth: "1px",
            pointerEvents: "none",
            minHeight: "17px",
            minWidth: "17px",
            fontSize: "12px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
        }> {docs[this.getEntityKey()].length}</div > : null;
    }

    render() {
        const style: React.CSSProperties = {};
        if (this.props.field.isSelected) {
            style.borderColor = "red";
            style.borderStyle = "solid";
            style.borderWidth = "1px"
        }
        const wrapped = this.props.field.wrappedField;
        if (!wrapped.visible) {
            return null;
        }
        const warning = <ConstraintsIndicator constraints={wrapped.constraintViolations} />;
        const docsButtonVisible: boolean = wrapped.appName != "StaticImage" && wrapped.allowDocuments;
        const documentUpload = <div style={{ position: "relative", visibility: docsButtonVisible ? "visible" : "hidden" }} > <Button iconName="paperclip" handleClick={this.handleAddAttachement}></Button>{this.getDocumentsIndicator()}</ div>;
        return <>
            <div style={style}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                        <Field
                            field={wrapped}
                            entity={this.props.entity}
                            dataSource={this.props.dataSource}
                            context={this.props.context}
                            handleEval={this.props.handleEval}
                            handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            onChange={this.props.onChange}
                            onDataLoaded={this.props.onDataLoaded}
                            commandManager={this.props.commandManager}
                        />
                    </div>
                    {documentUpload}
                </div>
                {wrapped.remark ? <RemarkPanelbar key={wrapped.remark}>{wrapped.remark}</RemarkPanelbar> : null}
                {warning}
            </div>
        </>
    }
}

const ConstraintsIndicator = ({ constraints }) => {
    if (!constraints || constraints.length == 0) {
        return null;
    }

    const allErrorIndicators = constraints.map((value, index) => {
        if (value.Severity == Severity.CriticalWarning) {
            return <div style={{ paddingTop: "5px" }}><CriticalWarningIndicator message={value.Message} /></div>
        }
        else if (value.Severity == Severity.Warning) {
            return <div style={{ paddingTop: "5px" }}><WarningIndicator message={value.Message} /> </div>
        }
        else {
            {
                return <div style={{ paddingTop: "5px" }}><ErrorIndicator message={value.Message} /></div>
            }
        }
    });
    return <div> {allErrorIndicators}</div>;
}

export const WarningIndicator = ({ message }) => {

    return (
        <div style={{
            backgroundColor: "#f8f8e8",
            borderLeftColor: "#f8c800",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#e0b630",
            display: "flex"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}>{message}</div></div>
    )
};

export const CriticalWarningIndicator = ({ message }) => {

    return (
        <div style={{
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}>{message}</div></div>
    )
};

export const ErrorIndicator = ({ message }) => {

    return (
        <div style={{
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex"
        }}> <FAIcon name="times" sameWidth={true} /><div style={{ marginLeft: "5px" }}>{message}</div></div>
    )
};

export class TreeMetadataBuilder {
    public getNodeInfo(descriptor: TreeMetadataDescriptor, node: any) {
        const canHaveChildren = !!descriptor.childrenArrayName;
        const nodeInfo = {
            Title: descriptor.getTitle(node),
            canHaveChildren: canHaveChildren,
            children: [],
            descriptor: descriptor,
            childArray: null,
            metadata: node
        };

        if (canHaveChildren) {
            const childrenArrayName = descriptor.childrenArrayName(node);
            if (node[childrenArrayName]) {
                nodeInfo.children = node[childrenArrayName].map(n => this.getNodeInfo(descriptor.childrenDescriptor, n));
            }
            nodeInfo.childArray = node[childrenArrayName];
        }

        return nodeInfo;
    }
}

interface AddFieldDialogProps {
    onClose
    onAddComponents
};

enum SearchState {
    closed,
    open,
    loadingQuestionStructure
}

class AddFieldDialog extends React.Component<AddFieldDialogProps, { searchState: SearchState, questionId: string, componentType: number, questionStructure?: any }> {
    private componentSearchProps: IsSearchFieldProps;
    constructor(props) {
        super(props);
        const componentHelper = ComponentHelper.createFactory();
        this.componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        this.componentSearchProps.field.searchWindowUrl = "DynamicSearch/Window/crQuestion?multi=true&isreleased=1&displayPattern=[[ShortTitle]]&cus_OnlyReleased=1";
        this.componentSearchProps.multiSelectMode = true;
        this.componentSearchProps.field.dataTextField = "ShortTitle";
        this.componentSearchProps.field.dataValueField = "Id";
        this.componentSearchProps.field.searchValueField = "Id";
        this.componentSearchProps.field.searchTextField = "ShortTitle";

        this.state = { searchState: SearchState.closed, questionId: null, componentType: 12 };
    }

    private handleExternalNewDataCheck = (data: any) => {
        let result = false;
        if (data)
            result = data.released === true;
        if (!result)
            NotificationHelper.showErrorMessage(Helper.getTranslation("Suche.ItemNotSelected"));
        return result;
    }

    handleAddQuestions = () => {
        if (this.state.questionStructure && this.state.questionStructure.length > 0) {
            const ct = this.state.questionStructure;
            this.props.onAddComponents(ct);
        }
    }

    handleCancel = () => {
        if (this.state.searchState == SearchState.closed) {
            this.props.onClose && this.props.onClose();
        }
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any) => {
        this.setState({ searchState: SearchState.loadingQuestionStructure, questionId: value })
        this.getQuestionStructure(value)
    }

    handleObjectChanged = (field: { model: string }, object: any) => {
        this.setState({ searchState: SearchState.loadingQuestionStructure, questionId: object.Id })
        this.getQuestionStructure(object.Id)
    }

    getQuestionStructure = (questionIDs: [{ Id: string }]) => {
        const questionStructureUrl = 'Reporting/GetQuestionStructure';
        const questions: any = {};
        questionIDs.map((q) => questions[q.Id] = q.Id);
        utility.httpService.postJson(Config.baseUrl + questionStructureUrl, { questionIDs: questionIDs.map((q) => q.Id) }, (result) => {

            if (result.Data && result.Data.length > 0) {
                result.Data.map((q) => { q.Id = kendo.guid(); this.remapTypes(q); });
            }

            this.setState({ questionStructure: result.Data, searchState: SearchState.closed });
        }, null, null, true);

    }

    remapTypes = (question: reportQuestion) => {

        switch (question.QuestionDataType) {
            case 5:
                question.Type = 8;
                break;
            default:
                question.Type = question.QuestionDataType;
        }

        if (question.AnswerReferences && question.AnswerReferences.length > 0) {
            question.Type = 5;
        }
    }

    handleComponentChanged = (event) => {
        this.setState({ componentType: Number.parseInt(event.target.value) });
    }

    render() {
        const value = this.state.questionId ? this.state.questionId : [];
        const dialog = this.state.searchState == SearchState.closed ? <BasicDialog
            title="Add field"
            width="50%"
            onSave={this.handleAddQuestions}
            onClose={this.handleCancel}>
            Question ids
            <IsSearchField {...this.componentSearchProps}
                onOpened={() => {
                    this.setState({ searchState: SearchState.open, questionStructure: null },
                        () => {
                            const sheet = General.Sheet.Manager.getTopMostSheet();
                            if (sheet)
                                sheet.setExternalNewDataCheck({ check: this.handleExternalNewDataCheck });
                        })
                }
                }
                onChange={this.handleFieldClicked}
                value={value}
                onClose={() => this.setState({ searchState: SearchState.closed })}
            />
            <ComponentSelector questionStructures={this.state.questionStructure} />
        </BasicDialog>
            : null
        return dialog;
    }
}



class ComponentSelector extends React.Component<{ questionStructures: reportQuestion[], }, any> {

    getSelectAnswerOptions = (rq: reportQuestion) => {
        if (!rq.AnswerReferences || rq.AnswerReferences.length == 0) {
            return null;
        }
        return <>
            <option value="5">Radio buttons</option>
            <option value="6">Check boxes</option>
            <option value="11">Picklist</option>
        </>
    }

    getEnterAnswerOptions = (rq: reportQuestion) => {
        if (rq.AnswerReferences && rq.AnswerReferences.length > 0) {
            return null;
        }

        switch (rq.Type) {
            case 1:
                return <option value="1">Int</option>
            case 2:
                return <option value="2">Float</option>
            case 3:
                return <option value="3">Boolean</option>
            case 0:
            case 4:
                return <>
                    <option value="0">Text</option>
                    <option value="4">Multiline text</option>
                </>
            case 8:
                return <option value="8">Local date</option>
            default:
        }
    }

    handleOptionChange = (rq: reportQuestion, event) => {
        rq.Type = Number.parseInt(event.target.value);
    }

    renderQuestions(questionStructures: reportQuestion[]) {
        const questions = questionStructures.map((q) => {
            return <tr>
                <td>
                    {q.Text}
                </td>
                <td>
                    <select onChange={this.handleOptionChange.bind(this, q)}>
                        {this.getSelectAnswerOptions(q)}
                        {this.getEnterAnswerOptions(q)}
                    </select>
                </td>
            </tr>

        });
        return questions;
    }

    render() {
        if (!this.props.questionStructures) {
            return null;
        }
        return <table>
            <thead>
                <tr>
                    <th>Question</th>
                    <th>Options</th>
                </tr>
            </thead>
            <tbody>
                {this.renderQuestions(this.props.questionStructures)}
            </tbody>
        </table>
    }
}